module.exports = __webpack_public_path__ + "static/img/feature_2.3abed8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/feature_2.png
// module id = /P75
// module chunks = 0